import React from 'react'

const Search = ({placeholder, onChange, onIndexChange, onLostFocus, onEnter, value, isOpen, controlName}, sRef) => {
  const ref = React.useRef(null)
  const focusSearchInput = React.useCallback(() => {
    if (ref.current) {
      ref.current.focus({
        preventScroll: true,
      })
    }
  }, [ref])

  React.useEffect(() => {
    if (isOpen) focusSearchInput()
  }, [isOpen])

  React.useImperativeHandle(sRef, () => ({
    focus: () => {
      focusSearchInput()
    },
  }))

  React.useLayoutEffect(() => {
    focusSearchInput()
  }, [focusSearchInput])

  return (
    <p className="control has-icons-left tw:mx-4 tw:mb-2">
      <input
        ref={ref}
        data-cy={`rselect-input-${controlName}`}
        type="text"
        placeholder={placeholder}
        className="input is-small"
        value={value}
        onChange={onChange}
        onKeyDown={e => {
          switch (e.key) {
            case 'ArrowUp':
              onIndexChange(-1)
              break
            case 'ArrowDown':
              onIndexChange(1)
              break
            case 'Enter':
              onEnter()
              break
            default:
              break
          }
        }}
        onBlur={onLostFocus}
        id="search"
      />
      <span className="icon is-small is-left">
        <i className="fa-solid fa-search" />
      </span>
    </p>
  )
}

export default React.forwardRef(Search)
